module.exports = __webpack_public_path__ + "media/images/blueboat-1c2180b70b71ac532272435d054dfe98.png";